module.exports = __webpack_public_path__ + "static/media/defaultPillImage.c65c887e.jpg";